import { Hotel } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import { getHotelDetailChildAndVariationsInfo } from '@utils/utils';
import { optimizeImage } from '@utils/imageOptimization';
import useGetasPath from '@hooks/useGetAsPath';
import { HotelDetailViewModel } from '@api/models/HotelDetailViewModel';
import { APP_STATIC } from '@config/app-static';

export const HotelDetailSchemaOrg = ({
  hotelDetail,
}: {
  hotelDetail: HotelDetailViewModel;
}) => {
  const asPath = useGetasPath();

  const url = `${process.env.NEXT_PUBLIC_HOST}${asPath}`;
  const {
    variations: [variationWithMinPrice, variationWithMaxPrice],
  } = getHotelDetailChildAndVariationsInfo(hotelDetail);
  const priceRange =
    variationWithMinPrice && variationWithMaxPrice
      ? variationWithMinPrice?.variation?.totalSellingPrice +
        ' - ' +
        variationWithMaxPrice?.variation?.totalSellingPrice
      : '';

  return (
    <Script
      defer
      {...jsonLdScriptProps<Hotel>({
        '@context': 'https://schema.org',
        '@type': 'Hotel',
        name: hotelDetail.name,
        url,
        image:
          optimizeImage(hotelDetail.images?.[0]?.url, 820, 404, {
            providerId: hotelDetail.images?.[0]?.providerId,
            placeholderUrl: hotelDetail.images?.[0]?.placeholderUrl,
          }) || '',
        description: hotelDetail?.metaDescription,
        priceRange,
        telephone: APP_STATIC.phone,
        address: [
          {
            '@type': 'PostalAddress',
            addressCountry: hotelDetail.countryCode,
            addressLocality: hotelDetail.city,
            streetAddress: hotelDetail.address,
          },
        ],
        photo: hotelDetail.images?.map((hotelImage) => ({
          '@type': 'ImageObject',
          contentUrl: hotelImage.url,
          description: hotelImage.hotelImageCategoryName,
        })),
        amenityFeature: hotelDetail.features?.map((feature) => ({
          '@type': 'LocationFeatureSpecification',
          value: 'true', //static value.
          name: feature.name,
        })),
      })}
    />
  );
};
